import { QuestionTypeEnum, TrueOrFalseQuestion } from '@/models/Question';
import { questionGenerator } from '@/data/generators/questionGenerator';

export function trueOrFalseQuestionGenerator(
  question?: Partial<TrueOrFalseQuestion>,
): TrueOrFalseQuestion {
  return {
    ...questionGenerator(question),
    type: QuestionTypeEnum.TRUE_OR_FALSE,
    isTrue: true,
    ...question,
  };
}
